import { $api } from '@service/RequestService';
import { stringifyUrl } from 'query-string';
import { useMutation, useQueryClient } from 'react-query';

import { shaxmatkaConstants } from '..';

export const useFlatSave = () => {
  const qc = useQueryClient();

  return useMutation(
    async (data: { flats: any[]; isConfirmedSoldAndBookedChangedParameters?: boolean }) => {
      const res = await $api.post(
        stringifyUrl({
          url: '/v1/flat',
          query: {
            isConfirmedSoldAndBookedChangedParameters: data?.isConfirmedSoldAndBookedChangedParameters
          }
        }),
        data?.flats
      );

      return res?.data?.data;
    },
    {
      onSuccess: async () => {
        await qc.invalidateQueries([shaxmatkaConstants.queryKeys.FLAT_FILTER_TABLE]);
      }
    }
  );
};
